import {Redirect, Route, Switch} from 'react-router-dom';
import Urls from '../../constants/urls';
import REScene from './REScene';
import {
  outdoorViewHotspots,
  officeHotspots,
  outdoorBackViewHotspots,
  kitchenHotspots,
  bathroomHotspots,
  bedroomViewHotspots
} from './data';

const RERooms = () => {
  return (
    <Switch>
      <Route
        {...Urls.realEstate.root}
        render={() => <Redirect to={Urls.realEstate.outdoorView.path} />}
      />
      <Route {...Urls.realEstate.bathroom}>
        <REScene
          id="re-bathroom"
          yRotation={360}
          hotspots={bathroomHotspots}
        />
      </Route>
      <Route {...Urls.realEstate.bedroomView}>
        <REScene
          id="re-bedroom-view"
          yRotation={360}
          hotspots={bedroomViewHotspots}
        />
      </Route>
      <Route {...Urls.realEstate.office}>
        <REScene
          id="re-office"
          yRotation={360}
          hotspots={officeHotspots}
        />
      </Route>
      <Route {...Urls.realEstate.kitchen}>
        <REScene
          id="re-kitchen"
          yRotation={360}
          hotspots={kitchenHotspots}
        />
      </Route>
      <Route {...Urls.realEstate.outdoorView}>
        <REScene
          id="re-outdoor-view"
          yRotation={270}
          hotspots={outdoorViewHotspots}
        />
      </Route>
      <Route {...Urls.realEstate.outdoorBackView}>
        <REScene
          id="re-outdoor-back-view"
          yRotation={270}
          hotspots={outdoorBackViewHotspots}
        />
      </Route>
    </Switch>
  );
};

export default RERooms;
